import { makeStyles, createMuiTheme } from '@material-ui/core';
import grey from '@material-ui/core/colors/grey';

export const themeOverrided = createMuiTheme({
  overrides: {
    MuiAppBar: {
      colorPrimary: {
        color: grey[900],
        backgroundColor: grey[100],
      },
    },
  },
});

const drawerWidth = 240;

export default makeStyles((theme) => ({
  root: {
    display: 'flex',
    minHeight: 80,
  },
  appBar: {
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  appBarShift: {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  menuButton: {
    marginRight: 36,
  },
  hide: {
    display: 'none',
  },
  drawer: {
    width: drawerWidth,
    flexShrink: 0,
    whiteSpace: 'nowrap',
  },
  drawerOpen: {
    width: drawerWidth,
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  drawerClose: {
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    overflowX: 'hidden',
    width: theme.spacing(7) + 1,
    [theme.breakpoints.up('sm')]: {
      width: theme.spacing(9) + 1,
    },
  },
  toolbar: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    padding: theme.spacing(0, 1),
    // necessary for content to be below app bar
    ...theme.mixins.toolbar,
  },
  content: {
    flexGrow: 1,
    paddingTop: theme.spacing(3),
  },
  avatar: {
    margin: 5,
    flexGrow: 1,
  },
  title: {
    flexGrow: 1,
    margin: '8px 0 0 0',
  },
  rightButtonTollbar: {
    position: 'absolute',
    right: '10px',
    display: 'inline-flex',
    flexDirection: 'row-reverse',
  },
}));
